import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Error from '../../common/ErrorMessage';
import AdminNav from '../../admin/AdminNav';

const RewardNotFoundComponent = ({ id, displayError }) => {
  return (
    <>
      <AdminNav />
      <h1>404. Reward not found</h1>
      <p>No reward found with ID: {id}</p>
      <p>
        <Link to="/admin/rewards">Back to all rewards</Link>
      </p>
      {displayError && displayError.message && (
        <>
          <p>
            <small>
              The following information may be useful for technical support:
            </small>
          </p>
          <Error error={displayError} />
        </>
      )}
    </>
  );
};

RewardNotFoundComponent.propTypes = {
  id: PropTypes.string.isRequired,
  displayError: PropTypes.shape({
    message: PropTypes.string,
  }),
};

RewardNotFoundComponent.defaultProps = {
  displayError: {},
};

export default RewardNotFoundComponent;
